<h2 mat-dialog-title>Confirm email delete</h2>
<div mat-dialog-content class="mat-typography">
  <p>Are you sure you want to delete this email address?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button color="warn" [mat-dialog-close]="true">DELETE</button>
</div>
